(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SettoreDetailController', SettoreDetailController);

    SettoreDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Settore'];

    function SettoreDetailController($scope, $rootScope, $stateParams, previousState, entity, Settore) {
        var vm = this;

        vm.settore = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:settoreUpdate', function(event, result) {
            vm.settore = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
